var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column",class:'item_' + _vm.classSuffix},[_c('div',{staticClass:"letter",class:_vm.getNextCalssColor()},[_vm._v(" "+_vm._s(_vm.data.split(" ").pop().substring(0, 1))+" ")]),_vm._v(" "+_vm._s(_vm.data)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }